import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default class ApplicationWrapper extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ToastContainer autoClose={2000} />
        <App />
      </Provider>
    );
  }
}

ReactDOM.render(<ApplicationWrapper />, document.getElementById("root"));

// Service worker disabled - users will always see the latest version
// To re-enable, change unregister() to register()
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
